import React from "react";
import { createContext } from "use-context-selector";
import { PRODUCTIVITY_PAGE_DEFAULT_FILTERS } from "../ProductivityPageHeader";

const ProductivityPageContext = createContext(null);

const ProductivityPageContextProvider = ({ children }) => {
  const [isInformationsLoading, setIsInformationsLoading] =
    React.useState(false);
  const [appliedFilters, setAppliedFilters] = React.useState(
    PRODUCTIVITY_PAGE_DEFAULT_FILTERS
  );
  const [productivityData, setProductivityData] = React.useState({
    fieldProductivity: [],
    typingProductivity: [],
    visitsStatus: [],
    consolidatedVisits: [],
    goals: [],
  });

  return (
    <ProductivityPageContext.Provider
      value={{
        appliedFilters,
        isInformationsLoading,
        productivityData,
        setAppliedFilters,
        setIsInformationsLoading,
        setProductivityData,
      }}
    >
      {children}
    </ProductivityPageContext.Provider>
  );
};

export { ProductivityPageContextProvider, ProductivityPageContext };
